import { SelectOption } from '@ardoq/select';
import { TypeOption } from '@ardoq/component-hierarchies';
import { actionCreator } from '@ardoq/rxbeach';
import { ComponentTypeWorkspaceMap } from './createComponentDialogTypes';

export type OpenCreateComponentDialogPayload = {
  componentTypeWorkspaceMap: ComponentTypeWorkspaceMap;
  componentTypeOptions: TypeOption[];
};

export const openCreateComponentDialog =
  actionCreator<OpenCreateComponentDialogPayload>(
    '[create component dialog] OPENED'
  );

export const closeCreateComponentDialog = actionCreator(
  '[create component dialog] CLOSED'
);

export const componentNameChanged = actionCreator<string>(
  '[create component dialog] NAME_CHANGED'
);

export const componentTypeOptionSelected = actionCreator<TypeOption | null>(
  '[create component dialog] COMPONENT_TYPE_OPTION_SELECTED'
);

export const workspaceOptionSelected =
  actionCreator<SelectOption<string> | null>(
    '[create component dialog] WORKSPACE_OPTION_SELECTED'
  );

export const requestOpenCreateComponentDialog = actionCreator(
  '[create component dialog] OPEN_REQUESTED'
);
